import styled from 'styled-components';

export const ItemCardUpper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;
